export class AddPipeCodes {
    pipeCodeId?: string;
    name?: string;
    description: string;
    active: boolean;
    pipeSizeType: number;
    pipeSpecs: AddPipeSpec[];
}
export class AddPipeSpec {
    name: string;
    pipeSpecId?: string;
    description: string;
    active: boolean;
    versions: AddPipeSpecVersion[];
}
export class AddPipeSpecVersion {
    pipeSpecVersionId?: string;
    pipeSpecId: string;
    calculationType: number;
    boltMaterialId: string;
    boltMaterialAliasId?: string;
    boltType?: string;
    breakout?: boolean;
    clampMaterialId?: string;
    flangeFacingTypeId?: string;
    flangeMaterialId?: string;
    flangeMaterialAliasId?: string;
    flangeTypeId?: string;
    gasketId?: string;
    gasketAliasId?: string;
    hubMaterialId?: string;
    kfactor?: number;
    lubricantId?: string;
    lubricantMode?: number;
    manufacturerId?: string;
    maximumPipeSizeId?: string;
    minimumPipeSizeId?: string;
    operatingPressure?: string;
    operatingTemperature?: string;
    percentageCover?: string;
    pipeScheduleId?: string;
    pressureClassId?: string;
    sealRingMaterialId?: string;
    standardId?: string;
    testPressure?: string;
    tighteningMethod?: number;
    tighteningSpecification?: string;
    tighteningSpecificationInput?: string;
    active: boolean;
    pipeSizeType?: number;
}

export class UpdatePipeCodeSpecification {
    pipeCodeId: string;
    name: string;
    description: string;
    active: boolean;
    pipeSizeType: number;
    pipeSpecs?: UpdatePipespec[];
}

export class UpdatePipespec {
    pipeSpecId: string;
    name?: string;
    versions?: AddPipeSpecVersion[];
    active: boolean;
}
